import { OwnPropertyQuestion } from '@hb/domain';
import { OwnPropertyPartStoreService } from '@hb/modules/extra-asset/own-property-part/own-property-part-store.service';
import { PreviousButtonComponent } from '@hb/modules';
import { SellingPriceComponent } from '@hb/modules/extra-asset/own-property-part/selling-price/selling-price.component';
import { MortgageGlobalComponent } from '@hb/modules/extra-asset/own-property-part/mortgage-amount/mortgage-amount.component';
import { OwnPropertyComponent } from '@hb/modules/extra-asset/own-property-part/own-property/own-property.component';

import { Subscription } from 'rxjs';
import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { ApContentModule } from '@ap/content';

@Component({
    selector: 'own-property-part',
    templateUrl: './own-property-part.component.html',
    standalone: true,
    imports: [
        ApContentModule,
        ReactiveFormsModule,
        PreviousButtonComponent,
        SellingPriceComponent,
        MortgageGlobalComponent,
        OwnPropertyComponent
    ]
})
export class OwnPropertyPartComponent implements OnInit, OnDestroy {
    protected readonly store = inject(OwnPropertyPartStoreService);
    protected activeQuestion: OwnPropertyQuestion;
    private activeQuestionSubscription: Subscription;

    ngOnInit(): void {
        this.activeQuestionSubscription = this.store
            .getActiveQuestion()
            .subscribe((activeQuestion) => (this.activeQuestion = activeQuestion));
    }

    ngOnDestroy(): void {
        this.activeQuestionSubscription.unsubscribe();
    }

    previousQuestion(): void {
        this.store.backQuestion();
    }

    showOwnProperty(): boolean {
        return (
            this.activeQuestion === OwnPropertyQuestion.OWN_PROPERTY_BUTTON ||
            (this.store.isActiveQuestion(OwnPropertyQuestion.OWN_PROPERTY_BUTTON) && this.store.isSummary)
        );
    }
    showSellingPrice(): boolean {
        return (
            (this.activeQuestion === OwnPropertyQuestion.SELLING_PRICE_INPUT && !this.store.isSummary) ||
            (this.store.isActiveQuestion(OwnPropertyQuestion.SELLING_PRICE_INPUT) && this.store.isSummary)
        );
    }
    showMortgageAmount(): boolean {
        return (
            (this.activeQuestion === OwnPropertyQuestion.MORTGAGE_AMOUNT_INPUT && !this.store.isSummary) ||
            (this.store.isActiveQuestion(OwnPropertyQuestion.MORTGAGE_AMOUNT_INPUT) && this.store.isSummary)
        );
    }
}
